import { HistoricalVisit, HistoricalVisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useHistoricalVisitCqrsGet = (visitId: number): UseCqrsQueryResult<HistoricalVisit> => {
   return useCqrsGet<HistoricalVisit>(() => {
      const query: HistoricalVisitQuery = new HistoricalVisitQuery();
      query.visitId = visitId;
      return query;
   });
};
